import React, {Component} from 'react'
import {Field, FieldsManager} from '../../../../data/services/fields'
import {XMarkIcon} from '@heroicons/react/24/outline'
import moment from 'moment'
import Resources from '../../../../data/services/resources'
import {DEFAULT_DATABASE_DATETIME_FORMAT} from '../../../../util/util-constants'
import {scrollErrorIntoViewFields} from '../../../../common/util/util-vanilla'
import ModalDefault from "../../../../common/components/modal/modal-default";
import {fieldsToHtml} from "../../../../common/util/util-fields";
import {LoaderLarge} from "../../../../common/components/loader";
import {createResource} from "../../../../data/actions/resource";
import LocalStorage from "../../../../util/localStorage";
import {pushNotification} from "../../../../data/actions/ui";

export default class WoBillingBulkBatchModal extends Component {

    constructor(props) {
        super(props)
        this.state = {
            items: []
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.show !== this.props.show && !!this.props.show && this.props.selectedItems) {
            this.setState({items: this.getItems()})
        }
        if (prevProps.show !== this.props.show && !this.props.show) {
            this.setState({items: []})
        }
    }

    submit = () => {
        this.setState({items: this.state.items.map(item => FieldsManager.validateFields(item))}, () => {
            if (this.state.items.every(item => FieldsManager.checkFieldsForErrors(item))) {
                this.props.dispatch(createResource({
                    user: LocalStorage.get('user'),
                    params: {
                        Items: this.state.items.map(item => FieldsManager.getFieldKeyValues(item))
                    },
                    onResultCallback: (result) => {
                        if (result.status === 0) this.props.onClose()

                        const ids = result.data?.ids || []

                        if (ids.includes(-1)) {
                            this.props.dispatch(pushNotification({
                                title: this.props.translate("text.no_items_inventory"),
                                messageType: "warning",
                                timeout: 3000
                            }))
                            return
                        }

                        if (ids.includes(-2)) {
                            this.props.dispatch(pushNotification({
                                title: this.props.translate("text.item_already_processed"),
                                messageType: "warning",
                                timeout: 3000
                            }))
                            return
                        }

                        this.props.dispatch(pushNotification({
                            title: this.props.translate("text.work_order_invoices_created"),
                            messageType: "success",
                            timeout: 3000
                        }))
                    },
                    resource: Resources.WorkOrdersBilling,
                    piggyResource: Resources.WorkOrdersBilling,
                    query: this.props.query
                }))
            } else {
                scrollErrorIntoViewFields(this.state.items)
            }
        })
    }

    handleInputChange = (name, value, index) => {
        let items = this.state.items
        items[index] = FieldsManager.updateField(items[index], name, value)
        this.setState({items})
    }

    handleRemoveItem = (index) => {
        this.setState({items: this.state.items.filter((_, i) => i !== index)}, () => {
            if (this.state.items.length === 0) this.props.onClose()
        })
    }

    getItems = () => {
        return this.props.selectedItems ? Object.values(this.props.selectedItems).map((item, index) => this.getFields(item, index)) : []
    }

    getFields = (item = {}, index) => {
        return {
            WorkOrderID: new Field('WorkOrderID', item.WorkOrderID, [''], false, 'hidden'),
            AutoCounter: new Field('AutoCounter', item.AutoCounter, [], true, 'text', {
                label: this.props.translate("wo_number"),
            }),
            Date: new Field('Date', moment().format(DEFAULT_DATABASE_DATETIME_FORMAT), ['required'], false, 'date'),
            DueDate: new Field('DueDate', moment().add(15, 'days').format(DEFAULT_DATABASE_DATETIME_FORMAT), ['required'], false, 'date'),
            BookDate: new Field('BookDate', moment().format(DEFAULT_DATABASE_DATETIME_FORMAT), ['required'], false, 'date'),
        }
    }

    render() {
        const {translate} = this.props

        const fieldsHtml = this.state.items.map((item, index) => {
            const itemToHtml = fieldsToHtml(Object.values(Object.assign({}, item)), translate, (name, value) => this.handleInputChange(name, value, index), {})

            return (
                <div key={index} className={'mb-5'}>
                    <div className={'flex justify-end'}>
                        <XMarkIcon onClick={() => this.handleRemoveItem(index)}
                                   className={'w-5 h-5 cursor-pointer'}/>
                    </div>
                    <div className={'grid gap-4 grid-cols-3'}>
                        {itemToHtml}
                    </div>
                    <div className="separator py-5"/>
                </div>
            )
        })

        return (
            <ModalDefault
                show={this.props.show}
                widthClass={'max-w-5xl'}
                title={translate('text.ProcessInvoice')}

                onButtonClick={this.submit}
                buttonLabel={translate('btn.save')}
                closeButtonLabel={translate('btn.Cancel')}
                onClose={this.props.onClose}
                buttonDisabled={this?.props?.isLoading}
            >
                <div className="relative p-5">
                    {this?.props?.isLoading && (
                        <LoaderLarge/>
                    )}

                    <div>
                        {fieldsHtml}
                    </div>
                </div>
            </ModalDefault>
        )
    }
}

